import {TenantInfo} from '../models/tenant.model';


/**
 *
 * These are the AppSumo users with the original fully unlimited deal.
 *
 */

export function isAppSumoOriginalPlan(tenant:TenantInfo) {
  return tenant.instructorPricingPlan?.includes("lifetime") && !tenant?.appsumoTierLimits;
}

/**
 *
 * These are the AppSumo or StackCommerce users with the new deal that has usage limits.
 *
 */

export function isLimitedLifetimePlan(tenant:TenantInfo) {
  return tenant.instructorPricingPlan?.includes("lifetime") && !!tenant?.appsumoTierLimits;
}

export function isStackCommerce(tenant: TenantInfo) {
  return tenant.lifetimeCampaignName?.toLowerCase()?.includes("stack")
}

export function getDealSiteName(tenant: TenantInfo) {
  if (isStackCommerce(tenant)) {
    return "StackCommerce"
  }
  else {
    return "AppSumo";
  }
}
